const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');
const { formatText } = require('core/i18n').i18n;
const calendarActions = require('actions/brokerMarketsCalendar');
const DateHelper = require('utilities/dateHelper');
const { toFirstUppercase } = require('utilities/stringHelper');
const moment = require('moment');
const { DATE_FORMAT_API, DATE_FORMAT_DAY_TEXT_LONG } = require('constants/index');
const { DATE_PICKER_CUSTOM_LOCALE } = require('constants/commonsComponents');
const { LoadingSection } = require('commonsComponents/loadingSection');
const MarketsViewCalendar = require('components/broker/brokerMarketsCalendar/MarketsViewCalendar/MarketsViewCalendar');
const GeneralViewCalendar = require('components/broker/brokerMarketsCalendar/GeneralViewCalendar/GeneralViewCalendar');

class BrokerMarketsCalendar extends React.Component {
    constructor(props) {
        super(props);
        this.onCalendarStateChange = this.onCalendarStateChange.bind(this);
    }

    componentDidMount() {
        this.props.requestEvents();
    }

    componentWillUnmount() {
        const today = moment().format(DATE_FORMAT_API);
        this.props.changeDay(today);
    }

    onCalendarStateChange(calendarDatePickerState) {
        this.props.changeDay(calendarDatePickerState.dateSelected);
    }

    /**
     * @param { Object } date Formated as DATE_FORMAT_API constant
     * @return { Array }
     */
    getPeriodText(weekDetails) {
        const from = moment(weekDetails.startOfWeek).date();
        const to = moment(weekDetails.endOfWeek).date();
        const monthTo = toFirstUppercase(
                        moment(weekDetails.endOfWeek).
                        locale(DATE_PICKER_CUSTOM_LOCALE).
                        format('MMMM')
        );

        // @todo: needs the language detection and change the order if its needed
        return [from, to, monthTo];
    }

    /**
     * @param { String } date Formated as DATE_FORMAT_API constant
     * @return { Array }
     */
    getTodayText(date) {
        const year = moment(date).format('YYYY');
        const month = toFirstUppercase(
            moment(date).locale(DATE_PICKER_CUSTOM_LOCALE).format("MMMM")
        );
        const dayText = toFirstUppercase(
            moment(date).locale(DATE_PICKER_CUSTOM_LOCALE).format(DATE_FORMAT_DAY_TEXT_LONG)
        );
        const day = moment(date).format('D');

        // @todo: needs the language detection and change the order if its needed
        return [dayText, day, month, year];
    }

    /**
     * @param { String } date Formated as DATE_FORMAT_API constant
     * @return { Object }
     */
    getWeekDays(date) {
        const weekMomentObject = DateHelper.getDaysOfWeek(date);
        return weekMomentObject.map(dateOfWeek => {
            return {
                day: dateOfWeek.format('DD'),
                date: dateOfWeek.format(DATE_FORMAT_API),
            };
        });
    }

    /**
     * @param { Object } date Formated as DATE_FORMAT_API constant
     * @return { Object }
     */
    getWeekDetails(date) {
        return {
            startOfWeek: moment(date).startOf('isoWeek').format(DATE_FORMAT_API),
            endOfWeek: moment(date).endOf('isoWeek').format(DATE_FORMAT_API),
        }
    }

    render() {
        const {
            immBrokerMarketsCalendar,
            section
        } = this.props;

        const dateSelected = immBrokerMarketsCalendar.get('dateSelected');

        const weekDetails = this.getWeekDetails(dateSelected);
        const daysOfWeek = this.getWeekDays(dateSelected);
        const periodText = this.getPeriodText(weekDetails);
        const todayText = this.getTodayText(dateSelected);
        const calendarEvents = immBrokerMarketsCalendar.getIn(['byDate', dateSelected, 'events'], []);
        const quantity = calendarEvents.size || 0;

        if ( immBrokerMarketsCalendar.get('isFetching') ) {
            return (<LoadingSection />);
        }

        if ( immBrokerMarketsCalendar.get('error') ) {
            return (<p>Ha ocurrido un error</p>);
        }

        if (section === 'markets') {
            return (
                <MarketsViewCalendar
                    dateSelected={dateSelected}
                    daysOfWeek={daysOfWeek}
                    periodText={periodText}
                    todayText={todayText}
                    marketAgendaText={formatText('broker-marketAgenda')}
                    seeAllEventsText={formatText('broker-seeAllEvents')}
                    eventsText={formatText('broker-events')}
                    quantity={quantity}
                    calendarEvents={calendarEvents}
                    handleCalendarStateChange={this.onCalendarStateChange}
                    pageName={this.props.pageName}
                />
            );
        }

        if (section === 'general') {
            return (
                <GeneralViewCalendar
                    todayText={this.getTodayText(weekDetails).splice(1, 2)}
                    marketAgendaText={formatText('broker-marketAgenda')}
                    eventsText={formatText('broker-events')}
                    quantity={quantity}
                    calendarEvents={calendarEvents}
                    pageName={this.props.pageName}
                />
            );
        }
    }
}

BrokerMarketsCalendar.propTypes = {
    changeDay: PropTypes.func,
    immBrokerMarketsCalendar: PropTypes.object.isRequired,
    section: PropTypes.string.isRequired,
    requestEvents: PropTypes.func.isRequired,
    pageName: PropTypes.string
}

BrokerMarketsCalendar.defaultProps = {
    changeDay: function(){}
}

module.exports.constructor = BrokerMarketsCalendar;

module.exports.BrokerMarketsCalendar = connect(null, {
    changeDay: calendarActions.changeDay,
    requestEvents: calendarActions.requestEvents
})(BrokerMarketsCalendar);
